// Shared message-tag metadata — a single source of truth for the tag glyph +
// color used by both the RightRail "Tagged messages" rail and the composer's
// TagSelector, so the two stay visually in sync. Keyed by tag type. `Icon` is a
// lucide-react component; `rgb` is stored as "R,G,B" so callers can build
// rgba(...) at any alpha on the fly.
import { AlertTriangle, Star, CheckSquare, Clock, Info } from "lucide-react";

export const TAG_META = {
  urgent:    { Icon: AlertTriangle, label: "Urgent",    rgb: "255,80,80"   },
  important: { Icon: Star,          label: "Important", rgb: "255,200,0"   },
  todo:      { Icon: CheckSquare,   label: "To Do",     rgb: "0,255,153"   },
  checkin:   { Icon: Clock,         label: "Check In",  rgb: "147,112,219" },
  fyi:       { Icon: Info,          label: "FYI",       rgb: "100,149,237" },
};
